import { MainPlayer } from '@stores/krpPlayerStores';

function krpRemoveHotspot(hotspotId: string) {
  const player = MainPlayer.get();
  if (!player) return;
  const titleId = player.getHotspotById(hotspotId)?.titleHotspotId;
  if (titleId) {
    player.removeHotspotById(titleId);
  }
  player.removeHotspotById(hotspotId);
}

export default krpRemoveHotspot;
